import { render, staticRenderFns } from "./gift-recharge.vue?vue&type=template&id=6ca76436&scoped=true"
import script from "./gift-recharge.vue?vue&type=script&lang=js"
export * from "./gift-recharge.vue?vue&type=script&lang=js"
import style0 from "./gift-recharge.vue?vue&type=style&index=0&id=6ca76436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca76436",
  null
  
)

export default component.exports